<ion-header>
  <ion-toolbar>
    <ion-title>Quotation Request</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="closeModal()" class="header-button-cancel unfilled-gray-btn">
        <ion-icon name="close-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <form [formGroup]="quotationForm" *ngIf="quotationForm">
    <ion-card-content>

      <!-- From Email -->
      <ion-item class="email-container" *ngIf="!viewOnly">
        <ion-label position="fixed">From</ion-label>
        <ion-select formControlName="fromEmail" interface="popover" placeholder="Select Email">
          <ion-select-option *ngFor="let email of allFromEmails" [value]="email">
            {{ email }}
          </ion-select-option>
        </ion-select>
      </ion-item>



      <!-- To Emails (Dynamic) -->
      <ion-item class="email-container" *ngIf="!viewOnly">
        <ion-label position="fixed">To</ion-label>
        <div class="email-wrapper">

          <div class="email-chips">
            <ion-chip class="chipstyle" *ngFor="let email of toEmails.controls; let i = index">
              {{ email.value }}
              <ion-icon name="close-outline" (click)="removeEmail(i)"></ion-icon>
            </ion-chip>
          </div>
          <ion-input formControlName="newEmail" type="email" placeholder="Add recipient email"
            (keyup.enter)="addEmail()"></ion-input>

          <span danger *ngIf="toEmails.errors?.['minEmails']" class="text-danger">
            *required
          </span>
        </div>
      </ion-item>


      <!-- Subject -->
      <ion-item>
        <ion-label position="fixed">Subject</ion-label>
        <div class="input-wrapper">
          <ion-input formControlName="subject" placeholder="Enter subject"></ion-input>
        </div>
      </ion-item>

      <span *ngIf="isFieldInvalid('subject')" class="text-danger" style="margin-top: 5px; margin-left: 15px;">
        *required
      </span>




      <!-- Client Information -->


      <h3 class="client-info-title">Client Information</h3>
      <ion-card class="client-info-card">
        <div>
          <div class="row">
            <div class="col-4">
              <p class="my-0"><strong>Destination :</strong></p>
              <p>{{ quotationForm.get('clientInfo.destination')?.value }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Trip Start Date :</strong></p>
              <p>{{ quotationForm.get('clientInfo.tripStartDate')?.value | date : 'dd MMM, yyy' }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Trip End Date :</strong></p>
              <p>{{ quotationForm.get('clientInfo.tripEndDate')?.value | date : 'dd MMM, yyy'}}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Are Dates Flexible :</strong></p>
              <p>{{ quotationForm.get('clientInfo.flexibleDays')?.value ? "Yes" : "No" }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Nights/Days :</strong></p>
              <p>{{ quotationForm.get('clientInfo.nightsDays')?.value }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Passengers :</strong></p>
              <p>{{ quotationForm.get('clientInfo.passengers')?.value }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Prefered Hotel category :</strong></p>
              <p>{{ quotationForm.get('clientInfo.hotelType')?.value || "--" }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Prefered No Of Rooms :</strong></p>
              <p>{{ quotationForm.get('clientInfo.noOfRooms')?.value || "--" }}</p>
            </div>
            <div class="col-4">
              <p class="my-0"><strong>Budget :</strong></p>
                <p>{{ quotationForm.get('clientInfo.budget')?.value ? (quotationForm.get('clientInfo.budget')?.value | currency : 'INR') : "--" }}</p>
            </div>
          </div>
        </div>

      </ion-card>

      <!-- Notes -->
      <ion-item>
        <div class="input-container">
          <app-text-formatting-input formControlName="notes" [inputHeight]="'lg'"></app-text-formatting-input>
        </div>

      </ion-item>
      <span style="margin-left: 15px;" *ngIf="isFieldInvalid('notes')" class="text-danger">
        *required
      </span>

      <!-- File Upload -->
      <!-- <ion-item lines="none" class="file-upload-container">
        <div>
          <ion-item class="file-upload-container" lines="none">
            <div class="file-upload-wrapper" lines="none">
              <div class="button-group"  *ngIf="!viewOnly">
                <ion-button (click)="fileInput.click()" class="file-upload-btn">
                  <ion-icon name="attach-outline"></ion-icon> Attach a file
                </ion-button>
                <ion-button fill="clear" style="color:#003366;" *ngIf="selectedFileName" (click)="clearFile()"
                  class="clear-btn">
                  <ion-icon name="close-circle-outline"></ion-icon> Clear
                </ion-button>
                <span *ngIf="fileErrorMessage !=''" class="text-danger" style="margin-top: 5px; margin-left: 15px;">
                  {{fileErrorMessage}}
                </span>
              </div>
              <input #fileInput type="file" hidden (change)="onFileSelected($event)">
              <p *ngIf="selectedFileName" class="file-name clickable-file ms-1" (click)="openAttachedFile()">{{
                selectedFileName }}</p>
            </div>
          </ion-item>


        </div>

      </ion-item> -->

      <!-- Confirmation Checkbox -->
      <ion-item lines="none" *ngIf="!viewOnly">
        <ion-checkbox formControlName="isConfirmed" slot="start"></ion-checkbox>
        <ion-label>
          I confirm that the information provided above is accurate and true to the best of my knowledge.
        </ion-label>
      </ion-item>

    </ion-card-content>


  </form>
</ion-content>

<ion-footer *ngIf="!viewOnly && quotationForm">
  <!-- Submit Button -->
  <div class="ion-padding-horizontal bg-light-gray email-footers fixed-footer">
    <ion-button class="filled-blue-btn" (click)="sendQuotation()" type="submit" [disabled]="quotationForm.invalid">
      {{loadData ? 'Resend email' : 'Send email'}}
    </ion-button>
  </div>
</ion-footer>